/**
 * 固定ページの Jimdo gallery slider に prev/next ボタン + ページ番号を付与。
 *
 * 対象:
 *   - .cc-m-gallery-container.cc-m-gallery-slider  (ul/li 構造、bxSlider 由来)
 *   - .cc-m-gallery-container.cc-m-gallery-cool    (div 構造)
 *
 * 動作:
 *   - cool 構造の場合、子要素を新規 track div でラップして scroll container を分離
 *     （元の gallery 自体が scroll container だとボタンが scroll content と一緒に
 *      動いて消える問題を回避）
 *   - 各カルーセルを wrap で囲み、wrap にボタンとカウンターを配置
 *   - ボタン位置は scrollContainer の垂直中央に絶対配置（画像中央に揃う）
 *   - prefers-reduced-motion: smooth → auto
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SCROLL_BEHAVIOR = prefersReducedMotion ? 'auto' : 'smooth';

  function init(gallery) {
    var isCool = gallery.classList.contains('cc-m-gallery-cool');
    var scrollContainer;
    var slides;

    if (isCool) {
      // cool: 子の cool-item 群を新規 track div に移動して scroll container 化
      var track = document.createElement('div');
      track.className = 'suiso-cool-track';
      var coolItems = gallery.querySelectorAll(':scope > .cc-m-gallery-cool-item');
      if (coolItems.length < 2) return;
      coolItems.forEach(function (item) { track.appendChild(item); });
      gallery.appendChild(track);
      scrollContainer = track;
      slides = track.querySelectorAll(':scope > .cc-m-gallery-cool-item');
    } else {
      // slider: 既存 ul を scroll container として使う
      scrollContainer = gallery.querySelector(':scope > ul');
      if (!scrollContainer) return;
      slides = scrollContainer.querySelectorAll(':scope > li:not(.bx-clone)');
    }
    if (slides.length < 2) return;

    // ARIA
    gallery.setAttribute('role', 'region');
    gallery.setAttribute('aria-roledescription', 'carousel');
    if (!gallery.getAttribute('aria-label')) {
      gallery.setAttribute('aria-label', 'ギャラリー（' + slides.length + '枚）');
    }
    for (var i = 0; i < slides.length; i++) {
      slides[i].setAttribute('role', 'group');
      slides[i].setAttribute('aria-roledescription', 'slide');
      slides[i].setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
    }

    // gallery を wrap で囲む（ボタン・カウンターの基準点）
    var wrap = document.createElement('div');
    wrap.className = 'suiso-carousel-wrap';
    gallery.parentNode.insertBefore(wrap, gallery);
    wrap.appendChild(gallery);

    // prev/next ボタン
    var btnPrev = document.createElement('button');
    btnPrev.type = 'button';
    btnPrev.className = 'suiso-carousel-nav suiso-carousel-nav--prev';
    btnPrev.setAttribute('aria-label', '前の画像へ');
    btnPrev.innerHTML = '&#x2039;';

    var btnNext = document.createElement('button');
    btnNext.type = 'button';
    btnNext.className = 'suiso-carousel-nav suiso-carousel-nav--next';
    btnNext.setAttribute('aria-label', '次の画像へ');
    btnNext.innerHTML = '&#x203A;';

    wrap.appendChild(btnPrev);
    wrap.appendChild(btnNext);

    btnPrev.addEventListener('click', function () {
      scrollContainer.scrollBy({ left: -scrollContainer.clientWidth, behavior: SCROLL_BEHAVIOR });
    });
    btnNext.addEventListener('click', function () {
      scrollContainer.scrollBy({ left: scrollContainer.clientWidth, behavior: SCROLL_BEHAVIOR });
    });

    // ページ番号カウンター
    var counter = document.createElement('div');
    counter.className = 'suiso-carousel-counter';
    counter.setAttribute('aria-live', 'polite');
    counter.innerHTML = '<span class="suiso-carousel-counter__current">1</span>'
      + ' / <span class="suiso-carousel-counter__total">' + slides.length + '</span>';
    wrap.appendChild(counter);
    var counterCurrent = counter.querySelector('.suiso-carousel-counter__current');

    // ボタンの垂直位置を scrollContainer（画像本体）の中央に揃える
    function positionButtons() {
      var rect = scrollContainer.getBoundingClientRect();
      var wrapRect = wrap.getBoundingClientRect();
      var centerY = rect.top - wrapRect.top + rect.height / 2;
      btnPrev.style.top = centerY + 'px';
      btnNext.style.top = centerY + 'px';
    }
    // 画像 load 完了後・resize 時に再計算
    positionButtons();
    window.addEventListener('load', positionButtons);
    window.addEventListener('resize', positionButtons);
    if (window.ResizeObserver) {
      new ResizeObserver(positionButtons).observe(scrollContainer);
    }

    // アクティブスライド更新（スクロール検知）
    var rafScheduled = false;
    function updateActive() {
      rafScheduled = false;
      var w = scrollContainer.clientWidth || 1;
      var activeIdx = Math.round(scrollContainer.scrollLeft / w);
      if (activeIdx < 0) activeIdx = 0;
      if (activeIdx >= slides.length) activeIdx = slides.length - 1;
      counterCurrent.textContent = activeIdx + 1;
      btnPrev.disabled = activeIdx === 0;
      btnNext.disabled = activeIdx >= slides.length - 1;
    }
    scrollContainer.addEventListener('scroll', function () {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(updateActive);
    });
    updateActive();
  }

  function initAll() {
    var galleries = document.querySelectorAll('.cc-m-gallery-container.cc-m-gallery-slider, .cc-m-gallery-container.cc-m-gallery-cool');
    for (var i = 0; i < galleries.length; i++) init(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
